/**
 * Request builders for custom content-source endpoints not covered by generic JSON:API utilities.
 */

export function getMentionsForContentSource(id: string) {
  return {
    url: `/api/mentions?filter[contentSourceId]=${encodeURIComponent(id)}&sort=mentionTimestamp`,
  };
}

export function getItemsForContentSource(id: string) {
  return {
    url: `/api/items?filter[contentSourceId]=${encodeURIComponent(id)}`,
  };
}

export function getRecipesForContentSource(id: string) {
  return {
    url: `/api/recipes?filter[contentSourceId]=${encodeURIComponent(id)}`,
  };
}

/**
 * Fetch a content-source record with summaries sideloaded.
 * Using include=summaries ensures summary data is available synchronously
 * for the async: false hasMany relationship.
 */
export function findContentSource(id: string) {
  return {
    url: `/api/content-sources/${encodeURIComponent(id)}?include=summaries`,
  };
}
